const KEYS = ["utm_source", "utm_medium", "utm_campaign", "fbclid"];
const STORE_KEY = "nn_utm";

export const captureUtm = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const stored = JSON.parse(sessionStorage.getItem(STORE_KEY) || "{}");
    KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) stored[k] = v;
    });
    sessionStorage.setItem(STORE_KEY, JSON.stringify(stored));
  } catch {
    /* sessionStorage unavailable */
  }
};

export const getUtm = () => {
  try {
    return JSON.parse(sessionStorage.getItem(STORE_KEY) || "{}");
  } catch {
    return {};
  }
};
